import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../../parts/SvgIcon";

const MEAL_TYPE_KEYS = {
  Breakfast: "mealPlannerMealType.breakfast",
  Lunch: "mealPlannerMealType.lunch",
  Snack: "mealPlannerMealType.snack",
  Dinner: "mealPlannerMealType.dinner",
};

/**
 * MealPlannerMealTypeHeader
 *
 * Component for displaying meal type headers in simplified meal planner
 * Shows meal type name and custom meal actions if applicable
 */
export const MealPlannerMealTypeHeader = ({
  mealType,
  basicMealTypes = ["Breakfast", "Lunch", "Snack", "Dinner"],
  viewMode = false,
  onDeleteCustomMeal,
}) => {
  const { t } = useTranslation("athlete-portal");
  const isCustomMeal = !basicMealTypes.includes(mealType);
  const displayMealType = MEAL_TYPE_KEYS[mealType]
    ? t(MEAL_TYPE_KEYS[mealType])
    : mealType;

  return (
    <div
      className={
        isCustomMeal
          ? "meal-type-header justify-around"
          : "meal-type-header justify-center"
      }
    >
      {isCustomMeal && !viewMode && (
        <div className="custom-meal-actions">
          <a
            onClick={(e) => {
              if (onDeleteCustomMeal) {
                onDeleteCustomMeal(e, mealType);
              }
            }}
          >
            <SvgIcon
              src="/img/new-icons/red-trash.svg"
              noFilterOnLight={true}
            />
          </a>
          <a href="/actions/refresh?modal[type]=custom-meal">
            <SvgIcon src="/img/new-icons/edit-pencil.svg" />
          </a>
        </div>
      )}
      <span>{displayMealType}</span>
    </div>
  );
};

MealPlannerMealTypeHeader.propTypes = {
  mealType: PropTypes.string.isRequired,
  basicMealTypes: PropTypes.arrayOf(PropTypes.string),
  viewMode: PropTypes.bool,
  onDeleteCustomMeal: PropTypes.func,
};



